import React from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function ActiveSiteIconLabel(props) {
  const { site } = props;

  if (site.data.isActive) {
    return (
      <div className="flex items-center space-x-1">
        <CheckIcon className="h-5 w-5 text-cs-green-500" aria-hidden="true" />
        <div className="text-sm text-cs-green-500">
          Active
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-1">
      <XMarkIcon className="h-5 w-5 text-cs-gray-400" aria-hidden="true" />
      <div className="text-sm text-cs-gray-400">
        Inactive
      </div>
    </div>
  );
}
